/* YG Cart Bundle Upsell — adds an upsell variant and refreshes the drawer using the theme's own render path. */
(function () {
  if (window.ygCartBundleAdd) return;
  window.ygCartBundleAdd = function (variantId, btn) {
    if (!variantId || window.__ygCbBusy) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    window.__ygCbBusy = true;
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      try {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') { cart.setActiveElement(document.activeElement); }
      } catch (e) {}
    }
    var config;
    if (typeof fetchConfig === 'function') {
      config = fetchConfig('javascript');
      if (config.headers) { config.headers['X-Requested-With'] = 'XMLHttpRequest'; delete config.headers['Content-Type']; }
    } else {
      config = { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' } };
    }
    config.body = formData;
    var addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(addUrl, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response && response.status) { throw new Error(response.description || 'Add to cart failed'); }
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'yg-cart-bundle-upsell', productVariantId: variantId });
          }
        } catch (e) {}
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        }
      })
      .catch(function (err) { if (window.console) { console.warn('[yg-cart-bundle]', err); } })
      .finally(function () { window.__ygCbBusy = false; if (btn) { btn.removeAttribute('aria-busy'); } });
  };
})();
